import axios from 'axios';
import { BASE_URI_DEVELOPMENT_CENTER } from '@/api/CONST.js';

const PREFIX = `${BASE_URI_DEVELOPMENT_CENTER}/statistics`;

/**
 * get solutions reports list
 * @returns Promise
 */
export const getSolutionsReports = () => axios.get(`${PREFIX}/reports/history`);

/**
 * download solutions summary report
 * @param {number|string} versionId version id
 * @return {Promise<AxiosResponse>}
 */
export const downloadSolutionsSummaryReports = versionId => axios.get(`${PREFIX}/versions/${versionId}/summary`);

/**
 * download solutions general report
 * @param {number|string} versionId version id
 * @return {Promise<AxiosResponse>}
*/
export const downloadSolutionsGeneralReports = versionId => axios.get(`${PREFIX}/versions/${versionId}/general`);

